import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from '@/apis/api';
import headerObject from '@/types/headerObj';
const localHost = apiUrl;

const endPoint = 'fetchOrganizationRepos/';
const url = localHost + endPoint;

const fetchOrganizationRepos = async (
  UUID: string,
  headerObj?: headerObject
) => {
  try {
    const res = await postWithAuth(
      url,
      {
        OrganizationUUID: UUID,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          Orguuid: UUID,
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    return data.Repositories;
  } catch (err) {
    console.error(err);
  }
};

export default fetchOrganizationRepos;
